/**
 * `@kitup/brand-talearoo/storefront` — TaleAroo's landing and pricing pages.
 *
 * A web-only entry point, like `/legal`: the pages are JSX and import pictures
 * and fonts, and the API imports the brand's root. Only `apps/web-talearoo`
 * imports this.
 *
 * The package manifest points this entry at the source, not at `dist`, on
 * purpose: `tsc` cannot emit the CSS and picture imports, so the app's bundler
 * compiles it. `tsconfig.build.json` leaves it out of the build for that reason.
 */
import type { Storefront } from '@kitup/brand';
import { brand } from './brand.js';
import { legal } from './legal.js';
import { LandingPage } from './storefront/LandingPage.js';
import { PricingPage } from './storefront/PricingPage.js';
import { WordmarkGlyphs } from './storefront/Header.js';
import './storefront/storefront.css';

export const storefront: Storefront = {
  landing: (page) => <LandingPage brand={brand} page={page} />,
  pricing: (page) => <PricingPage brand={brand} legal={legal} page={page} />,
  // `ta-storefront` carries the palette and the display font the mark is drawn in.
  logo: ({ size }) => (
    <span className={`ta-storefront ta-logo ta-logo-${size}`}>
      <span className="ta-mark">
        <WordmarkGlyphs />
      </span>
    </span>
  ),
};
